<template>
  <div class="col p-3 h-100">
    <div class="card card-body h-100 bg-dark">
      <div id="map" class="map-container" ref="map"></div>
    </div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import basemap from "../assets/ri-clean-combined.json";

function onEachFeature(feature, layer) {
  layer.on('mouseover', () => {
    layer.setStyle({
        weight: 4,
        opacity: 0.7
    });
  }),
  layer.on('mouseout', () => {
    layer.setStyle({
        weight: 1,
        opacity: 0.85
    });
  })
}

function getColor(d) {
    return d >  80 ? '#031633' :
           d >  50 ? '#052c65' :
           d >  20 ? '#084298' :
           d >   5 ? '#0a58ca' :
                     '#0d6efd';
}

function mapStyle(feature) {
  return {
      fillColor: getColor(feature.properties.percent_out),
      color: "#1b1b1b",
      weight: 1,
      fillOpacity: 0.85,
      opacity: 0.85,
  };
}

var mapOptions = {
  attributionControl: false,
  zoomControl: false,
  zoomSnap: 0.02,
  zoomDelta: 0.08,
  scrollWheelZoom: false,
  touchZoom: false,
  doubleClickZoom: false,
  boxZoom: false,
  keyboard: false,
  dragging: false,
  background: "None",
};

export default {
  name: "Map",
  props: {
    mapData: Array,
    msg: String
  },
  data() {
    return {
      map: null,
      layer: null,
      bounds: null,
      resizeMap: null
    };
  },
   mounted() {
    basemap.features.forEach((element) => {
      this.mapData.find((newElement) => {
        if (element.properties.NAME == newElement.name) {
          element.properties.outages = newElement.customers_affected
          element.properties.percent_out = newElement.percent_out
        }
      })
    })

    this.map = L.map('map', mapOptions).setView([0, 0], 3);

    this.layer = L.geoJSON(basemap, { style: mapStyle, onEachFeature: onEachFeature.bind(this) })
      .bindTooltip(function (layer) {
        var name = layer.feature.properties.NAME;
        var value = layer.feature.properties.outages.toLocaleString();
        var pct = layer.feature.properties.percent_out;
        return name + "<br>" + value + " (" + pct + "%)"
      })

    this.bounds = this.layer.getBounds()
    this.map.addLayer(this.layer);
    this.map.fitBounds(this.bounds);

    window.addEventListener('resize', () => {
      if (this.resizeMap) {
        clearTimeout(this.resizeMap)
      }
      this.resizeMap = setTimeout(() => {
        this.map.invalidateSize({pan:false})
        console.log(this.bounds)
        console.log(this.map)
        this.map.fitBounds(this.bounds);
        this.resizeMap = null

      }, 250)
    }, true)

  },
  methods: {
    updateMap: function () {
      basemap.features.forEach((element) => {
        this.mapData.find((newElement) => {
          if (element.properties.NAME == newElement.name) {
            element.properties.outages = newElement.customers_affected
            element.properties.percent_out = newElement.percent_out
          }
        })
      })
      this.layer.clearLayers()
      this.layer.addData(basemap)
    }
  },
  watch: {
    mapData: {
      deep: true,
      handler() {
        this.updateMap()
      }
    }
  }
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 100%;
  min-height: 450px
}

.leaflet-container {
  background-color: rgba(255, 0, 0, 0);
}
</style>